var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelWidgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3867 201.6C69.0133 201.6 65.3867 197.973 65.3867 193.6V171.52C65.3867 167.147 69.0133 163.52 73.3867 163.52C77.76 163.52 81.3867 167.147 81.3867 171.52V193.6C81.3867 198.08 77.76 201.6 73.3867 201.6Z",
    fill: "#6B456A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 201.6C123.627 201.6 120 197.973 120 193.6V149.333C120 144.96 123.627 141.333 128 141.333C132.373 141.333 136 144.96 136 149.333V193.6C136 198.08 132.373 201.6 128 201.6Z",
    fill: "#6B456A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.613 201.6C178.24 201.6 174.613 197.973 174.613 193.6V127.253C174.613 122.88 178.24 119.253 182.613 119.253C186.987 119.253 190.613 122.88 190.613 127.253V193.6C190.613 198.08 187.093 201.6 182.613 201.6Z",
    fill: "#6B456A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3867 140.587C69.76 140.587 66.56 138.133 65.6 134.507C64.5333 130.24 67.0933 125.867 71.4667 124.8C110.72 114.987 145.28 93.5467 171.627 62.9333L176.533 57.1733C179.413 53.8667 184.427 53.44 187.84 56.32C191.147 59.2 191.573 64.2133 188.693 67.6267L183.787 73.3867C155.307 106.667 117.76 129.813 75.3067 140.373C74.6667 140.587 74.0267 140.587 73.3867 140.587Z",
    fill: "#6B456A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.613 101.547C178.24 101.547 174.613 97.92 174.613 93.5467V70.4H151.36C146.987 70.4 143.36 66.7733 143.36 62.4C143.36 58.0267 146.987 54.4 151.36 54.4H182.613C186.987 54.4 190.613 58.0267 190.613 62.4V93.6533C190.613 98.0267 187.093 101.547 182.613 101.547Z",
    fill: "#6B456A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160 242.667H96C38.08 242.667 13.3333 217.92 13.3333 160V96C13.3333 38.08 38.08 13.3333 96 13.3333H160C217.92 13.3333 242.667 38.08 242.667 96V160C242.667 217.92 217.92 242.667 160 242.667ZM96 29.3333C46.8266 29.3333 29.3333 46.8267 29.3333 96V160C29.3333 209.173 46.8266 226.667 96 226.667H160C209.173 226.667 226.667 209.173 226.667 160V96C226.667 46.8267 209.173 29.3333 160 29.3333H96Z",
    fill: "#6B456A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelWidgetIcon);
export default __webpack_public_path__ + "static/media/levelWidgetIcon.04058141917a757330aa0c0acb591967.svg";
export { ForwardRef as ReactComponent };